import React from "react";
import "./Button.scss";

function Button({ buttonText, onClick, disabled }) {
  return (
    <Button className="button-style" onClick={onClick} disabled={disabled}>
      {buttonText}
    </Button>
  );
}

export default Button;
